import { makeAutoObservable } from "mobx";

export default class ChatStore {
    constructor() {
        this._sessions = []           // список чатов (для арендодателя)
        this._currentChat = null      // текущий открытый чат
        this._messages = []           // сообщения текущего чата
        this._isLoading = false       // индикатор загрузки
        this._unreadCount = 0         // можно потом добавить счётчик непрочитанных

        makeAutoObservable(this);
    }

    // --------- SETTERS ----------
    setSessions(sessions) {
        this._sessions = sessions;
    }

    setCurrentChat(chat) {
        this._currentChat = chat;
    }

    setMessages(messages) {
        this._messages = messages;
    }

    // 💡 ИСПРАВЛЕНО: Для MobX лучше использовать spread/push
    addMessage(message) {
        // Если сообщение с таким ID уже есть — выходим, чтобы не дублировать
        if (message.id && this._messages.some(m => m.id === message.id)) {
            return;
        }
        this._messages.push(message);
    }

    setIsLoading(bool) {
        this._isLoading = bool;
    }

    bumpSessionToTop(chatId) {
        const index = this._sessions.findIndex(
            s => String(s.id) === String(chatId)
        );

        if (index <= 0) return false;

        const [session] = this._sessions.splice(index, 1);
        this._sessions.unshift(session);
        return true;
    }

    clearUnreadCount(chatId) {
        // Ищем чат по ID. Важно привести типы, если вдруг id строка/число
        const chatToUpdate = this._sessions.find(s => String(s.id) === String(chatId));

        if (chatToUpdate) {
            // Обнуляем счетчик
            chatToUpdate.unreadCount = 0;
            console.log(`✅ MobX: Счетчик обнулен для чата ${chatId}`);
        } else {
            console.warn(`⚠️ MobX: Чат с id ${chatId} не найден для сброса счетчика`);
        }
    }

    // 🚀 ДОБАВЛЕН МЕТОД: Обновление сессии и сортировка
    updateSession(newSessionData) {
        const index = this._sessions.findIndex(
            s => String(s.id) === String(newSessionData.id)
        );

        if (index > -1) {
            const oldSession = this._sessions[index];

            this._sessions[index] = {
                ...oldSession,
                ...newSessionData,
                userAvatarUrl: newSessionData.userAvatarUrl || oldSession.userAvatarUrl,
                add: oldSession.add || {}
            };

            return true;
        }

        const draftSession = {
            id: newSessionData.id,
            ...newSessionData,
            userAvatarUrl: newSessionData.userAvatarUrl || null,
            add: newSessionData.add || { title: "Новое обращение", address: "" },
        };

        this._sessions.push(draftSession);
        return true;
    }

    clearStore() {
        this._sessions = [];
        this._currentChat = null;
        this._messages = [];
        this._isLoading = false;
    }

    markAllOwnMessagesAsRead() {
        this.messages.forEach(msg => {
            if (msg.isOwnMessage) {
                msg.isRead = true;
            }
        });
    }

    // --------- GETTERS ----------
    get sessions() {
        return this._sessions;
    }

    get currentChat() {
        return this._currentChat;
    }

    get messages() {
        return this._messages;
    }

    get isLoading() {
        return this._isLoading;
    }


    get unreadChatsCount() {
        // 1. Фильтруем массив: оставляем только те чаты, где счетчик > 0.
        // 2. Считаем, сколько таких чатов осталось.
        return this._sessions.filter(session => (session.unreadCount || 0) > 0).length;
    }

    get totalUnreadCount() {
        return this._sessions.reduce((total, session) => {
            return total + (session.unreadCount || 0);
        }, 0);
    }
}